import React from 'react';
import { motion } from 'framer-motion';
import { FaAddressBook, FaGit, FaHackerrank, FaHeart, FaLetter, FaLinkedin, FaMedium, FaPhone, FaTwitter, FaVoicemail } from 'react-icons/fa';

const Footer = () => {
  const socialLinks = [
    { name: 'GitHub', icon: <FaGit />, link: 'https://github.com/DivitaP' },
    { name: 'LinkedIn', icon: <FaLinkedin />, link: 'https://www.linkedin.com/in/divita-phadakale-304120168/' },
    { name: 'Twitter', icon: <FaTwitter />, link: 'https://x.com/divita_p' },
    { name: 'Medium', icon: <FaMedium />, link: 'https://medium.com/@divitaphadakale21' }
  ];

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Experience', href: '#experience' },
    { name: 'Projects', href: '#projects' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <motion.div
            className="footer-brand"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="brand-logo">
              <span className="logo-bracket">{'<'}</span>
              <span className="logo-text">Divita Phadakale</span>
              <span className="logo-bracket">{'/>'}</span>
            </div>
            <p className="brand-tagline">
              Digital Architect & Full-Stack Developer specializing in high-performance experiences.
              Let's craft something extraordinary together.
            </p>
            <div className="footer-status">
              <motion.div
                className="status-indicator"
                animate={{
                  scale: [1, 1.2, 1],
                  opacity: [1, 0.5, 1]
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              />
              <span>Available for Hire</span>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            className="footer-links"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="links-list">
              {quickLinks.map((link, index) => (
                <motion.li
                  key={link.name}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.2 + index * 0.1 }}
                >
                  <a href={link.href}>
                    <span className="link-arrow">▹</span>
                    {link.name}
                  </a>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Social Links */}
          <motion.div
            className="footer-social"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="footer-heading">Connect</h4>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={social.name}
                  href={social.link}
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.3 + index * 0.1 }}
                  whileHover={{ scale: 1.2, y: -5 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <span>{social.icon}</span>
                  <span className="social-tooltip">{social.name}</span>
                </motion.a>
              ))}
            </div>
            <p className="contact-email">
              <a href="mailto:divita.phadakale@colorado.edu">
                divita.phadakale@colorado.edu
              </a>
            </p>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="footer-divider" />
          <div className="bottom-content">
            <p className="copyright">
              © {new Date().getFullYear()} Divita Phadakale. All Rights Reserved.
            </p>
            <p className="made-with">
              Made with <motion.span
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ duration: 1, repeat: Infinity }}
              ><FaHeart/></motion.span> in Boulder, Colorado
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
